import { Stack } from "@mui/material";
import { motion } from "framer-motion";
import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import CustomPaper from "../../_components/CustomPaper";
import IconComponent from "../../components/ui/IconComponent";
import { ANIM_PROFILE_DURATION, slideAnimationReverse } from "../../_app/animation-consts";
import { useTranslation } from "react-i18next";
import { LANG_KEY } from "../../_i18n/config";
import { myChangeLanguage } from "../../_i18n/utils";
import Text from "../../_components/Text";
import { FC } from "react";

const LanguagePage: FC = () => {
  const { i18n, t } = useTranslation("profile");

  const toggleLanguage = (lang: "ru" | "en") => {
    myChangeLanguage(lang);
    localStorage.setItem(LANG_KEY, lang);
  };

  return (
    <PageLayout
      header={<Header pageTitle={t("language")} needBack />}
      contentSx={{ padding: "20px 8px 0" }}
    >
      <motion.div
        layout
        initial="in"
        animate="animate"
        exit="out"
        variants={slideAnimationReverse}
        transition={{ duration: ANIM_PROFILE_DURATION }}
      >
        <Stack direction={"column"} justifyContent={"center"} spacing={1}>
          <CustomPaper onClick={() => toggleLanguage("en")}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
              <Stack direction={"row"} alignItems={"center"} spacing={3}>
                <IconComponent
                  style={{ position: "relative", zIndex: 1 }}
                  iconName={"UK"}
                  type="asBackground"
                  size={40}
                />
                <Text variant="regular-semi">English</Text>
              </Stack>

              {i18n.language === "en" && <IconComponent iconName={"Check"} hasStroke hasFill />}
            </Stack>
          </CustomPaper>

          <CustomPaper
            onClick={() => toggleLanguage("ru")}
            sx={{ pointerEvents: "none", opacity: 0.5 }}
          >
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
              <Stack direction={"row"} alignItems={"center"} spacing={3}>
                <IconComponent
                  style={{ position: "relative", zIndex: 1 }}
                  iconName={"Russia"}
                  type="asBackground"
                  size={40}
                />
                <Text variant="regular-semi">{t("russian")}</Text>
              </Stack>

              {i18n.language === "ru" && <IconComponent iconName={"Check"} hasStroke hasFill />}
            </Stack>
          </CustomPaper>
        </Stack>
      </motion.div>
    </PageLayout>
  );
};

export default LanguagePage;
